module.exports = __webpack_public_path__ + "images/duravermeer2cbcc6db165a7c7765aaf90cb557d815.png";